var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotesIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "34px",
    viewBox: "0 0 51 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-quotes-953503") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-Copy-5",
    transform: "translate(-49, -1269)",
    fill: "#00467D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-quotes-953503",
    transform: "translate(49, 1269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7233333,11.3333333 C45.9566667,11.3333333 51,16.4333333 51,22.6666667 C51,28.9 45.9,34 39.6666667,34 C33.4333333,34 28.3333333,28.9 28.3333333,22.6666667 C28.3333333,10.1433333 38.4766667,0 51,0 C51,0 43.5766667,2.77666667 39.7233333,11.3333333 Z M22.6666667,22.6666667 C22.6666667,28.9 17.5666667,34 11.3333333,34 C5.1,34 0,28.9 0,22.6666667 L0,22.6666667 C0,10.1433333 10.1433333,0 22.6666667,0 C22.6666667,0 15.2433333,2.77666667 11.39,11.3333333 C17.6233333,11.3333333 22.6666667,16.4333333 22.6666667,22.6666667 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotesIconBlue);
export default __webpack_public_path__ + "static/media/quotes-icon--blue.842452aaaa2cabbbb22fab85daf222e3.svg";
export { ForwardRef as ReactComponent };